export const parseVodId = (input: string): string => {
    const regex = /[^\s:]+:(\d+(?::\d+)?)/
    const match = input.match(regex)
    return match ? match[1] : input
}
